import { useTranslations } from 'next-intl';

import { getPageNameKey } from './utils';

interface HeaderTitleProps {
  pathname: string;
}

interface WrapperHeaderProps {
  children: React.ReactNode;
}

const WrapperHeader: React.FC<WrapperHeaderProps> = ({ children }: WrapperHeaderProps) => {
  return <h1 className="hidden lg:flex min-w-0 flex-1 items-center gap-2 overflow-hidden text-xl font-medium">{children}</h1>;
};

const HeaderTitle: React.FC<HeaderTitleProps> = ({ pathname }: HeaderTitleProps) => {
  const t = useTranslations('layout');
  const comingSoon = useTranslations('common.comingSoon');

  if (pathname === '/liquidations' || pathname.startsWith('/liquidations/')) return null;

  return (
    <WrapperHeader>
      <span title={t(getPageNameKey(pathname))} className="min-w-0 truncate text-text-primary">
        {t(getPageNameKey(pathname))}
      </span>
      {pathname === '/yield-bearing-vaults' && (
        <span className="hidden shrink-0 rounded-full border border-border-primary bg-surface-secondary px-3 py-1 text-xs font-normal text-text-secondary xl:inline-flex">
          {comingSoon('title')}
        </span>
      )}
    </WrapperHeader>
  );
};

export default HeaderTitle;
